export type ProfileConfiguration = {
    //
    // general
    //
    business: {
        dashboard: boolean;
        outstanding: boolean;
    };

    outstanding: {
        read: boolean;
        write: boolean;
        otherUserAccess: boolean;
    };
    //
    //
    //
    budget: {
        read: boolean;
        write: boolean;
        import: boolean;
    };

    salesInvoice: {
        read: boolean;
        write: boolean;
    };

    expenseReport: {
        read: boolean;
        readOnlySelf: boolean;
        write: boolean;
        writeOnlySelf: boolean;
        validateWrite: boolean;
    };

    document: {
        read: boolean;
        write: boolean;
        importPurchaseInvoice: boolean;
        importSalesInvoice: boolean;
        importMultiSalesInvoice: boolean;
        onlySelf: boolean;
        statusDisplay: boolean;
    };

    tag: {
        read: boolean;
        write: boolean;
    };

    bankAccount: {
        read: boolean;
        write: boolean;
        delete: boolean;
    };

    bankTransaction: {
        import: boolean;
        read: boolean;
        write: boolean;
    };
    //
    // accounting
    //
    accountingPeriod: {
        read: boolean;
        write: boolean;
    };

    accounting: {
        read: boolean;
        write: boolean;
        import: boolean;
        export: boolean;
        accountingLine: boolean;
        log: boolean;
        generalLedger: boolean;

        dashboard: boolean;
        openPoints: boolean;
        audit: boolean;
        monitoring: boolean;
        auditReport: boolean;
    };

    auditReport: {
        // access: boolean // Deprecated
        // review: boolean // Deprecated

        read: boolean;
        write: boolean;
        enableReview: boolean;
    };

    capitalAsset: {
        read: boolean;
        write: boolean;
    };

    declaration: {
        read: boolean;
        write: boolean;
    };

    task: {
        read: boolean;
        write: boolean;
    };
    //
    // boni/mali
    //
    gainOrLoss: {
        read: boolean;
        write: boolean;
    };
    //
    // chat
    //
    chat: {
        read: boolean;
        write: boolean;
        onlySelf: boolean;
    };

    //
    // internalManagement
    //
    internalManagement: {
        access: boolean;
        userActivity: boolean;
        importEBIC: boolean;
        bobbeeBilling: boolean;
    };

    accountingFirmSettings: {
        read: boolean;
        write: boolean;
    };

    accountingUser: {
        read: boolean;
        write: boolean;
    };

    accountingClient: {
        read: boolean;
        write: boolean;
    };

    accountingWorkspace: {
        read: boolean;
        write: boolean;
    };

    engagementLetter: {
        read: boolean;
        write: boolean;
    };

    accountingRule: {
        read: boolean;
        write: boolean;
        // writeRestricted: boolean
    };

    // taxForm: {
    //     read: boolean,
    //     write: boolean,
    //     import: boolean
    // },

    // help: {
    //     accounting: boolean,
    //     accountingClient: boolean,
    //     businness: boolean
    // },

    profile: {
        read: boolean;
        write: boolean;
    };

    company: {
        read: boolean;
        write: boolean;
    };

    stock: {
        read: boolean;
        write: boolean;
    };

    user: {
        read: boolean;
        write: boolean;
    };

    offer: {
        read: boolean;
        write: boolean;
    };

    controlCenter: {
        read: boolean;
        write: boolean;
    };
};

export type KeyOf<T> = keyof T;

type Paths<T, Depth extends number = 5> = [Depth] extends [never]
    ? never
    : {
          [K in keyof T]: T[K] extends object
              ? `${K & string}.${Paths<T[K], Prev[Depth]>}`
              : K & string;
      }[keyof T];

type Prev = [never, 0, 1, 2, 3, 4, 5];

export type ProfileConfigurationPath = Paths<ProfileConfiguration>;

export type PrimaryResource = KeyOf<ProfileConfiguration>;

export type Action =
    | "read"
    | "write"
    | "import"
    | "export"
    | "delete"
    | "otherUserAccess"
    | "enableReview"
    | "onlySelf"
    | "readOnlySelf"
    | "writeOnlySelf"
    | "dashboard"
    | "validateWrite"
    | "generalLedger"
    | "log"
    | "monitoring"
    | "audit"
    | "openPoints"
    | "auditReport"
    | "access"
    | "userActivity"
    | "importEBIC"
    | "bobbeeBilling"
    | "accountingLine";

export type PrismaQuery = "findUnique" | "findFirst" | "findMany";

export type TableName =
    | "accountableAccount"
    | "accountableAccountTable"
    | "accountableAccountTableMapping"
    | "accountableAccountRule"
    | "accountableAccountTag"
    | "accountingClosing"
    | "accountingFirmClient"
    | "accountingFirmClientPrice"
    | "bobbeePrice"
    | "bobbeePriceList"
    | "accountingItemExport"
    | "accountingItemImport"
    | "accountingLine"
    | "accountingPeriod"
    | "accountingReview"
    | "accountingReviewLayout"
    | "applicationSettings"
    | "auditCheck"
    | "auditCheckResult"
    | "bank"
    | "bankAccount"
    | "bankAccountBalance"
    | "bankTransaction"
    | "bankTransactionWordingPattern"
    | "budget"
    | "budgetFormLine"
    | "chat"
    | "chatMessage"
    | "chatUser"
    | "company"
    | "accountingWorkspace"
    | "companyActivity"
    | "companyActivitySuggestion"
    | "companyScope"
    | "companySuggestion"
    | "companyUser"
    | "computedIndicator"
    | "dashboardSetting"
    | "declaration"
    | "declarationForm"
    | "document"
    | "documentRule"
    | "documentUpdateStatus"
    | "engagementLetter"
    | "expenseReport"
    | "file"
    | "testFile"
    | "forbiddenReconciliation"
    | "invoiceNumberPattern"
    | "userSubscription"
    | "mail"
    | "manualUserActivity"
    | "operatingAccount"
    | "partitionTag"
    | "payment"
    | "profile"
    | "profileCompany"
    | "reconciliation"
    | "partialTaxPayment"
    | "tag"
    | "task"
    | "thirdPartyCompanyData"
    | "thirdPartyCompanyTag"
    | "user"
    | "userActivity"
    | "userToken"
    | "vatDeclaration"
    | "zTillReceipt"
    | "bookletTemplate"
    | "exportTheme"
    | "exportOffice"
    | "learningObject"
    | "learningModule"
    | "importMapping"
    | "exportMapping"
    | "connectorSetting"
    | "extension"
    | "stockInventory"
    | "stockInventoryLine"
    | "stockOperation"
    | "ressourceAllocation"
    | "invoice"
    | "invoiceLine"
    | "invoiceProduct"
    | "invoiceTheme";

export const defaultConfiguration: ProfileConfiguration = {
    business: {
        dashboard: false,
        outstanding: false,
    },

    outstanding: {
        read: false,
        write: false,
        otherUserAccess: false,
    },
    budget: {
        read: false,
        write: false,
        import: false,
    },

    salesInvoice: {
        read: false,
        write: false,
    },
    expenseReport: {
        read: false,
        readOnlySelf: false,
        write: false,
        writeOnlySelf: false,
        validateWrite: false,
    },
    //
    // general
    //
    document: {
        read: false,
        write: false,
        importPurchaseInvoice: false,
        importSalesInvoice: false,
        importMultiSalesInvoice: false,
        onlySelf: false,
        statusDisplay: false,
    },

    tag: {
        read: false,
        write: false,
    },

    bankAccount: {
        read: false,
        write: false,
        delete: false,
    },

    bankTransaction: {
        import: false,
        read: false,
        write: false,
    },
    //
    // accounting
    //
    accountingPeriod: {
        read: false,
        write: false,
    },

    accounting: {
        read: false,
        write: false,
        import: false,
        export: false,
        accountingLine: false,
        log: false,
        generalLedger: false,
        dashboard: false,
        openPoints: false,
        audit: false,
        monitoring: false,
        auditReport: false,
    },

    auditReport: {
        // access: false, Deprecated
        // review: false, Deprecated

        read: false,
        write: false,
        enableReview: false,
    },

    capitalAsset: {
        read: true,
        write: true,
    },

    declaration: {
        read: true,
        write: true,
    },

    task: {
        read: false,
        write: false,
    },
    //
    // chat
    //
    chat: {
        read: false,
        write: false,
        onlySelf: false,
    },

    //
    // internalManagement
    //
    internalManagement: {
        access: false,
        userActivity: false,
        importEBIC: false,
        bobbeeBilling: false,
    },

    accountingFirmSettings: {
        read: false,
        write: false,
    },

    accountingUser: {
        read: false,
        write: false,
    },

    accountingClient: {
        read: false,
        write: false,
    },

    accountingWorkspace: {
        read: false,
        write: false,
    },

    engagementLetter: {
        read: false,
        write: false,
    },
    //
    // boni/mali
    //
    gainOrLoss: {
        read: false,
        write: false,
    },

    accountingRule: {
        read: false,
        write: false,
        // writeRestricted: false,
    },

    // taxForm: {
    //     read: false,
    //     write: false,
    //     import: false,
    // },

    // help: {
    //     accounting: false,
    //     accountingClient: false,
    //     businness: false
    // },

    profile: {
        read: false,
        write: false,
    },

    company: {
        read: false,
        write: false,
    },

    stock: {
        read: false,
        write: false,
    },

    user: {
        read: false,
        write: false,
    },
    offer: {
        read: true,
        write: false,
    },

    controlCenter: {
        read: false,
        write: false,
    },
};
